// extracted by mini-css-extract-plugin
export default {"payment":"pH","title_row":"qH","border_bottom":"rH","promo_wrapper":"sH","payment_wrapper":"tH","label":"uH","card_row":"vH","cardcontain":"wH","card_input":"xH","card_error":"yH","card_label":"zH","lock":"AH","same_address":"BH","place_order_button":"CH","buttonwrap":"EH","hide_form":"FH","paypal_buttons":"GH","review_button":"HH","alt_payment":"IH"};
    if(module.hot) {
      // 1743628927222
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  